<template>
  <v-container class="pa-0">
    <!-- <v-divider class="mt-3" /> -->
    <v-card
      elevation="1"
      class="mt-3"
      outlined
    >
      <v-card-title class="px-2 py-3 orderTitle">
        {{ `下單時間：${orderInfo.orderDate}` }}
        <v-btn
          outlined
          color="primary"
          class="ml-2"
          width="75"
          @click="orderInfoDialog = true"
        >
          訂房內容
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="btnList[isUserParams()][tabs]"
          color="primary"
          width="75"
          @click="btnList[isUserParams()][tabs].func"
        >
          {{ btnList[isUserParams()][tabs].text }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-row
        no-gutters
        align="center"
      >
        <v-col cols="3">
          <v-img
            aspect-ratio="1"
            :src="orderInfo.img"
            class="ma-2"
          />
        </v-col>
        <v-col>
          <v-card-text class="px-3 py-1">
            {{ `訂位營區：${orderInfo.name}` }}
          </v-card-text>
          <v-card-text class="px-3 py-1">
            {{ `訂單編號：${orderInfo.orderId}` }}
          </v-card-text>
          <v-card-text class="px-3 py-1">
            {{ `訂單金額：${orderInfo.price}` }}
          </v-card-text>
          <v-card-text class="px-3 py-1">
            {{ `訂單狀態：${orderInfo.orderStatus}` }}
            <!-- <span>（{{ orderInfo.updatedAt }}）</span> -->
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      v-model="orderInfoDialog"
    >
      <v-card

        class="pa-2"
      >
        <OrderInfo
          :order-room-list="orderInfoObj.orderRoomList"
          :is-search="true"
          :order-info-obj="orderInfoObj"
          @reduceOrderQuantity="reduceOrderQuantity"
        >
          <template v-slot:dialogActions>
            <v-btn
              color="primary"
              @click="orderInfoDialog = false"
            >
              關閉視窗
            </v-btn>
          </template>
        </OrderInfo>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import OrderInfo from '/src/components/OrderInfo.vue'

export default {
  components: {
    OrderInfo
  },
  props: {
    orderInfo: Object,
    tabs: Number
  },
  data () {
    return {
      orderInfoObj: {
        dateRange: ['2022-05-01', '2022-05-02'],
        totalPrice: 2400,
        orderRoomList: [
          {
            id: 1,
            name: '小木屋1',
            orderQuantity: 1,
            total: 1200,
            isNightOut: false
          },
          {
            id: 2,
            name: '小木屋2',
            total: 1200,
            orderQuantity: 1,
            isNightOut: true
          }
        ]
      },
      orderInfoDialog: false,
      btnList: {
        // 0不是客人
        1: {
          0: { text: '匯款回報', func: this.payReply },
          1: { text: '入場憑證', func: this.auth }
        },
        0: {
          0: { text: 'LINE提醒', func: this.notify },
          1: { text: '現場報到', func: this.checkIn }
        }
      }

      // orderStatusList:{
      //   0:'待付款',
      //   1:''
      // }
    }
  },
  methods: {
    reduceOrderQuantity (id) {
      // this.campList.filter((x) => {
      //   if (x.id === id) {
      //     x.orderQuantity -= 1
      //   }
      // })
      // this.orderRoom()
      // console.log('campList',this.campList);
    },
    payReply () {
      console.log('payReply')
    },
    auth () {
      console.log('auth')
    },
    notify () {},
    checkIn () {},
    isUserParams () {
      // if (this.$route.params.isUser !== '0' || this.$route.params.isUser !== '1') {
      //   return '1'
      // }
      return this.$route.params.isUser !== '0' ? '1' : '0'
    }
  }
}
</script>

<style scoped>
.orderTitle {
  font-size: 16px;
}
</style>
